import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0316eec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "practice-people" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-heading" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "People"),
  /*#__PURE__*/_createElementVNode("h2", null, "View all employees")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "stats-row"
}
const _hoisted_4 = {
  key: 1,
  class: "stats-row"
}
const _hoisted_5 = { class: "stats" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("# of"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("principals")
], -1))
const _hoisted_7 = { class: "stats" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("# of"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("employees")
], -1))
const _hoisted_9 = { class: "stats" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Total of"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("solicitors")
], -1))
const _hoisted_11 = { class: "stats" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("# of"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("solicitor"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("members")
], -1))
const _hoisted_13 = { class: "stats" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("# of life"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("members")
], -1))
const _hoisted_15 = { class: "stats" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("# total"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("members")
], -1))
const _hoisted_17 = { class: "stats" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Membership"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("takeup")
], -1))
const _hoisted_19 = { class: "stats" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Authorised"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("signatories")
], -1))
const _hoisted_21 = { class: "stats" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("ILP"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Directors")
], -1))
const _hoisted_23 = { class: "bottom-half" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Show", -1))
const _hoisted_25 = { class: "radio-row" }
const _hoisted_26 = { class: "radio" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Solicitors")
], -1))
const _hoisted_28 = { class: "radio" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Authorised signatories")
], -1))
const _hoisted_30 = { class: "radio" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "ILP Directors")
], -1))
const _hoisted_32 = { class: "radio" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Trust Coordinator")
], -1))
const _hoisted_34 = { class: "radio" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Authorised Trust Contact")
], -1))

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_PracticePeopleSolicitors = _resolveComponent("PracticePeopleSolicitors")
  const _component_PracticePeopleSignatories = _resolveComponent("PracticePeopleSignatories")
  const _component_PracticePeopleDirectors = _resolveComponent("PracticePeopleDirectors")
  const _component_PracticePeopleTrustCoordinator = _resolveComponent("PracticePeopleTrustCoordinator")
  const _component_PracticePeopleAuthorisedTrustContact = _resolveComponent("PracticePeopleAuthorisedTrustContact")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    (_ctx.loadingStat)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_LoadingIndicator)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loadingStat)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.stat.numberOfPrincipals), 1),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.stat.numberOfEmployees), 1),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.stat.totalSolicitors), 1),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.stat.numberOfSolicitorMembers), 1),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.stat.numberOfLifeMembers), 1),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.stat.numberOfTotalMembers), 1),
            _hoisted_16
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.stat.membershipTakeup), 1),
            _hoisted_18
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.stat.totalAuthorizedSignatories), 1),
            _hoisted_20
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.stat.totalIlpDirectors), 1),
            _hoisted_22
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      _hoisted_24,
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("label", _hoisted_26, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: "status",
            value: 1,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.showMode) = $event))
          }, null, 512), [
            [_vModelRadio, _ctx.showMode]
          ]),
          _hoisted_27
        ]),
        _createElementVNode("label", _hoisted_28, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: "status",
            value: 2,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.showMode) = $event))
          }, null, 512), [
            [_vModelRadio, _ctx.showMode]
          ]),
          _hoisted_29
        ]),
        _createElementVNode("label", _hoisted_30, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: "status",
            value: 3,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.showMode) = $event))
          }, null, 512), [
            [_vModelRadio, _ctx.showMode]
          ]),
          _hoisted_31
        ]),
        _createElementVNode("label", _hoisted_32, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: "status",
            value: 4,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.showMode) = $event))
          }, null, 512), [
            [_vModelRadio, _ctx.showMode]
          ]),
          _hoisted_33
        ]),
        _createElementVNode("label", _hoisted_34, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: "status",
            value: 5,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.showMode) = $event))
          }, null, 512), [
            [_vModelRadio, _ctx.showMode]
          ]),
          _hoisted_35
        ])
      ]),
      (_ctx.showMode=='1')
        ? (_openBlock(), _createBlock(_component_PracticePeopleSolicitors, {
            key: 0,
            onLoadStatData: _ctx.loadStatData
          }, null, 8, ["onLoadStatData"]))
        : _createCommentVNode("", true),
      (_ctx.showMode=='2')
        ? (_openBlock(), _createBlock(_component_PracticePeopleSignatories, {
            key: 1,
            onLoadStatData: _ctx.loadStatData,
            allowEdit: true
          }, null, 8, ["onLoadStatData"]))
        : _createCommentVNode("", true),
      (_ctx.showMode=='3')
        ? (_openBlock(), _createBlock(_component_PracticePeopleDirectors, {
            key: 2,
            onLoadStatData: _ctx.loadStatData
          }, null, 8, ["onLoadStatData"]))
        : _createCommentVNode("", true),
      (_ctx.showMode=='4')
        ? (_openBlock(), _createBlock(_component_PracticePeopleTrustCoordinator, {
            key: 3,
            onLoadStatData: _ctx.loadStatData,
            allowEdit: true
          }, null, 8, ["onLoadStatData"]))
        : _createCommentVNode("", true),
      (_ctx.showMode=='5')
        ? (_openBlock(), _createBlock(_component_PracticePeopleAuthorisedTrustContact, {
            key: 4,
            onLoadStatData: _ctx.loadStatData,
            allowEdit: true
          }, null, 8, ["onLoadStatData"]))
        : _createCommentVNode("", true)
    ])
  ]))
}